// extracted by mini-css-extract-plugin
module.exports = {"sizesContainer":"GiftWithPurchaseSizes_sizesContainer__jDSgI","size":"GiftWithPurchaseSizes_size__ifAVM","showMoreButton":"GiftWithPurchaseSizes_showMoreButton__PS9Bk"};